// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cp-j";
export var fulfillmentFormRail = "_cp-i";
export var headerTitleRow = "_cp-l";
export var orderDetailsWrapper = "_cp-g";
export var orderLinkTrigger = "_cp-2";
export var paymentInformationGrid = "_cp-q";
export var paymentSummaryColumn = "_cp-r";
export var phoneShipmentPickerButton = "_cp-e";
export var phoneShipmentPickerButtonContent = "_cp-f";
export var phoneShipmentPickerButtonWrapper = "_cp-d";
export var phoneShipmentPickerTrigger = "_cp-c";
export var shipmentContainer = "_cp-k";
export var shipmentDetailsMainPane = "_cp-h";
export var shipmentNavigationCard = "_cp-a";
export var shipmentNavigationEdgeTrigger = "_cp-6";
export var shipmentNavigationRail = "_cp-3";
export var shipmentNavigationRailEnter = "_cp-5";
export var shipmentNavigationRailHeader = "_cp-9";
export var shipmentNavigationRailOverlay = "_cp-4";
export var shipmentNavigationScrim = "_cp-7";
export var shipmentSummaryFact = "_cp-n";
export var shipmentSummaryGrid = "_cp-m";
export var shipmentSummaryMetadataRow = "_cp-o";
export var shipmentSummaryTags = "_cp-p";
export var shipmentWorkspace = "_cp-0";
export var shipmentWorkspaceBodyTablet = "_cp-8";
export var shipmentWorkspaceContent = "_cp-b";
export var shipmentWorkspaceHeader = "_cp-1";